<template>
  <div>
    <div class="row">
      <div class="w-50">
        <div class="jumbotron border border-success m-3 text-center rounded">
          <h1 class="text-success">{{activePM.length}}</h1>
          <h4 class="text-success">Active</h4>
        </div>
      </div>
      <div class="w-50">
        <div class="jumbotron border border-danger m-3 text-center rounded">
        <h1 class="text-danger">{{expiredPM.length}}</h1>
        <h4 class="text-danger">Expired</h4>
      </div>
      </div>
    </div>

    <h4 class="mt-5">Add Prime Memeber</h4>
    <hr class="bg-dark">

    <div class="input-group mb-3">
      <input
        type="text"
        class="form-control"
        v-model="newPMId"
        ref="newPM"
        placeholder="User ID"
      />
      <input
        type="date"
        class="form-control"
        v-model="toDate"
        ref="toDate"
      />
      <div class="input-group-append">
        <button @click="addPrimeMember" class="btn btn-outline-success">Add</button>
      </div>
    </div>

    <h4 class="mt-5">Active Prime Members</h4>
    <hr class="bg-dark">
    <table class="table table-striped w-100" v-if="activePM.length > 0">
      <thead>
        <tr>
          <th>Sl.No</th>
          <th>Name</th>
          <th>Username</th>
          <th>User Id</th>
          <th>Valid Till</th>
          <th>Remove</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(pm,index) in activePM" :key="index">
          <td>{{index+1}}</td>
          <td>{{ pm.first_name }} {{pm.last_name}}</td>
          <td><a :href="'https://t.me/'+pm.username" target="blank">{{ pm.username }}</a></td>
          <td>{{ pm.id }}</td>
          <td>{{ pm.toDate }}</td>
          <td>
            <button @click="deletePrimeMember(pm.id)" class="btn btn-outline-danger btn-sm">Remove</button>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="alert alert-info" role="alert" v-else>
      <strong>Info!</strong> No Active Prime member found.
    </div>

    <h4 class="mt-5">Expired Prime Members</h4>
    <hr class="bg-dark">
    <table class="table table-striped w-100" v-if="expiredPM.length > 0">
      <thead>
        <tr>
          <th>Sl.No</th>
          <th>Name</th>
          <th>Username</th>
          <th>User Id</th>
          <th>Valid Till</th>
          <th>Remove</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(pm,index) in expiredPM" :key="index">
          <td>{{index+1}}</td>
          <td>{{ pm.first_name }} {{pm.last_name}}</td>
          <td><a :href="'https://t.me/'+pm.username" target="blank">{{ pm.username }}</a></td>
          <td>{{ pm.id }}</td>
          <td>{{ pm.toDate }}</td>
          <td>
            <button @click="deletePrimeMember(pm.id)" class="btn btn-outline-danger btn-sm">Remove</button>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="alert alert-info" role="alert" v-else>
      <strong>Info!</strong> No Expired Prime member found.
    </div>
    
    <loading :active.sync="isLoading" :can-cancel="true" color="green"></loading>
  </div>
</template>

<script>
import TelegramService from "@/services/TelegramService";
import ApiService from "@/services/ApiService";

import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";


export default {
  name: 'PrimeMembers',
  components:{
    Loading
  },
  data: function () {
    return{
      user: this.$store.state.user,
      newPMId: null,
      toDate: null,
      isLoading: false,
    }
  },
  props:{
    primeMembers: Array,
    activePM: Array,
    expiredPM: Array,
    token: String
  },
  methods:{
    addPrimeMember(){
      if (this.newPMId == null || this.newPMId.trim() == "") {
        this.$refs.newPM.focus();
        return;
      }
      if (this.toDate == null || this.newPMId.trim() == "") {
        this.$refs.toDate.focus();
        return;
      }

      for (let index = 0; index < this.primeMembers.length; index++) {
        const pm = this.primeMembers[index];
        if(pm.id == parseInt(this.newPMId)){
          this.$dialog.alert("Given User is already a Prime Member");
          return;
        } 
      }

      TelegramService.getChat(this.token, this.newPMId)
        .then(
          function(tele_result) {
            this.isLoading = true;
            let now = new Date()
            let primeMembers = this.primeMembers
            let activePM = this.activePM
            let expiredPM = this.expiredPM
            primeMembers.push({id: parseInt(this.newPMId), toDate: this.toDate});
            tele_result['toDate'] = this.toDate
            ApiService.updateBotPrimeMembers(this.user, this.token, primeMembers)
              .then(
                function(result){
                  if(now < new Date(this.toDate.concat(" 23:59:59"))){
                    activePM.push(tele_result)
                  }else{
                    expiredPM.push(tele_result)
                  }
                  this.newPMId = null;
                  this.toDate = null;
                  this.$dialog.alert("Prime Member Added Successfully!");
                  this.$emit('updatePrimeMembers', result.primeMembers, activePM, expiredPM)
                }.bind(this)
              )
              .catch(function(response){
                  this.$dailog.alert(response.description);
                }.bind(this)
              );
          }.bind(this)
        )
        .catch(
          function(error) {
            console.log(error)
            this.$dialog.alert("User ID not valid");
          }.bind(this)
        )
        .finally(function () {
          this.isLoading = false;
        }.bind(this)
      );
    },

    deletePrimeMember(userID){
      this.$dialog.confirm("Do you want to remove this Prime Member?")
        .then(function() {
          userID = parseInt(userID)
          let primeMembers = this.primeMembers.filter(function(PM) {
            return PM.id != userID;
          });
          let activePM = this.activePM
          let expiredPM = this.expiredPM
          ApiService.updateBotPrimeMembers(this.user, this.token, primeMembers)
          .then(function(result){
            activePM = this.activePM.filter(function(PM) {
              return PM.id != userID;
            });
            expiredPM = this.expiredPM.filter(function(PM) {
              return PM.id != userID;
            });
            this.$emit('updatePrimeMembers', result.primeMembers, activePM, expiredPM);
            this.$dialog.alert("Prime Member Deleted");
            }.bind(this)
          )
          .catch(function(response) {
              this.$dailog.alert(response.description);
            }.bind(this)
          ); 
        }.bind(this))
      
    },
  },
  
}

</script>
